<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-toolbar flat height="130">
      <ExportLinks
        export-key="company-store-redemption-debt"
        :filters="{ ...filtersData, date_period: filtersData.date }"
      />
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" class="d-flex">
        <v-menu :close-on-content-click="true" offset-y max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field
              :label="translations.range[lang]"
              color="secondary"
              class="mr-4"
              rounded
              outlined
              dense
              clearable
              hide-details
              :prepend-inner-icon="icons.mdiCalendarSearch"
              v-on="on"
              v-model="filtersData.date"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="filtersData.date"
            color="secondary"
            type="month"
            no-title
          ></v-date-picker>
        </v-menu>

        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="redemptionInvoice"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="serverItemsLength"
      :loading="loading"
      :options.sync="options"
      class="b-outlined"
    ></v-data-table>
  </v-tab-item>
</template>

<script>
import { mdiCalendarSearch } from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import ExportLinks from '@/components/general/ExportLinks.vue';
import translations from '@/utils/translations/loyaltyPanel/branchDebt/redemptionInvoice';

export default {
  name: 'BranchDebt',

  mixins: [translations],

  components: { ExportLinks },

  data() {
    return {
      icons: { mdiCalendarSearch },
      page: +this.$route.query.page,
      filtersData: {
        date: '',
        order: null,
      },
      search: '',
      options: {},
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),
    ...mapState('loyaltyPanel/branchDebt', ['redemptionInvoice']),

    lang() {
      return this.$route.params.lang;
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },

    headers() {
      return [
        {
          text: this.translations.storeId[this.lang],
          value: 'store_id',
        },
        {
          text: this.translations.name[this.lang],
          value: 'store_name',
        },
        {
          text: this.translations.address[this.lang],
          value: 'store_address',
        },
        {
          text: this.translations.points[this.lang],
          value: 'points',
        },
        {
          text: this.translations.totalRedeemCoupons[this.lang],
          value: 'total_redeem_coupons',
        },
        {
          text: this.translations.date[this.lang],
          value: 'date_period',
        },
      ];
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/branchDebt', ['getRedemptionInvoice']),

    handleSearch() {
      let sendingData = {
        query: `?q=${this.search}`,
        filters: this.filtersData,
      };
      this.getRedemptionInvoice(sendingData);
    },

    getFilteredData() {
      let sendingData = {
        query: this.query,
        filters: this.filtersData,
      };
      this.getRedemptionInvoice(sendingData);
    },
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  mounted() {
    this.filtersData.date = moment().subtract(1, 'months').format('YYYY-MM');
  },

  watch: {
    options: {
      handler(val) {
        if (val.sortBy[0]) {
          this.filtersData.order = val.sortBy[0].split('[')[0];

          if (val.sortDesc) {
            this.filtersData.order += ',' + (val.sortDesc[0] ? 'desc' : 'asc');
          }
          this.getFilteredData();
        }
      },
      deep: true,
    },
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      let sendingData = {
        query: this.query,
        filters: this.filtersData,
      };
      this.getRedemptionInvoice(sendingData);
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    ['filtersData.date']: {
      immediate: true,
      handler(val) {
        if (val) {
          this.filtersData.date = moment(val).format('YYYY-MM');
          let sendingData = {
            query: this.query,
            filters: this.filtersData,
          };
          this.getRedemptionInvoice(sendingData);
        }
      },
    },

    search(val) {
      if (val == null) {
        let sendingData = {
          query: this.query,
          filters: this.filtersData,
        };
        this.getRedemptionInvoice(sendingData);
      } else {
        this.debouncedSearch();
      }
    },
  },
};
</script>
